import React, { Component } from 'react';

// Displays new collection card
class NewCollectionCard extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className={`post-grid__item col-12 col-xl-3 col-lg-4 col-md-4 col-sm-6 sandra-entity`}>
        <div className="posts__item posts__item--card posts__item--category-1 posts__item--category-4 card">
          <figure className="posts__thumb">
            <div className="posts__cat">
              <span className="label posts__cat-label posts__cat-label--kusama">{process.env.REACT_APP_CHAIN_NAME}</span>
              <span className="label posts__cat-label posts__cat-label--category-1">RMRK</span>
            </div>
            <img src={`https://everdreamsoft.mypinata.cloud/ipfs/${process.env.REACT_APP_DEFAULT_COLLECTION_IMAGE_IPFS}`} alt="collection image" className="lazy" data-src-data-src-ref="imageUrl" />
          </figure>
          <div className="posts__inner card__content">
            <a className="btn btn-primary" id="new-collection-popup-link" onClick={() => this.props.changeVisibilities({ collectionGallery: false, mint: true })}>New collection</a>

            <div className="posts__excerpt">
              <span data-ref="description">Use this button to create a new collection</span><br />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default NewCollectionCard;